import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CircleCall, AddAgent, AgentListBox, CallIconRound, CallIconSpan } from './style.js';
export class RecentList extends Component {
  renderCallType( type ) {
    if (type == 'Inbound' || type == 'incomming' ) {
      return (
        <CallIconRound>
          <CallIconSpan
            style={{
              "fontSize": "2.1rem",
              "color": "#28a6de",
              "fontWeight": 600,
            }}
            class="material-symbols-outlined"
          >
          phone_callback
          </CallIconSpan>
        </CallIconRound>
      );
    } else if( type == 'Missed' ){
      return (
        <CallIconRound>
          <CallIconSpan
            style={{
              "fontSize": "2.1rem",
              "color": "#e34242",
              "fontWeight": 600,
            }}
            class="material-symbols-outlined"
          >
            phone_missed
          </CallIconSpan>
        </CallIconRound>
      );
    }
    return (
      <CallIconRound>
        <CallIconSpan
          style={{
            "fontSize": "2.1rem",
            "color": "#ffbd5d",
            "fontWeight": 600,
          }}
          class="material-symbols-outlined"
        >
          call
        </CallIconSpan>
      </CallIconRound>
    );
  }
  render() {
    const { image, name, message, time, dialNumber, callInfo, iconWidth, extraMessage } = this.props;
    return (
      <div className="hoverChat">
        <AgentListBox>
          <CircleCall style={{ cursor: 'pointer' }} onClick={() => {
                dialNumber(callInfo);
          }}>
            <a
              
            >
              {/* <img style={{"width": iconWidth || "20px"}} src={} /> */}
              { this.renderCallType(image)}
            </a>
          </CircleCall>
          <h6 style={{
            display: "inline-block",
			flexGrow: 1,
            width: "30%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: 700,
            fontSize: "15px",
            lineHeight: "16px",
            letterSpacing: "0.02em",
            color: "#303030"
          }}>
            {name}
            {/* {extraMessage && <br /> } */}
            {/* {extraMessage && <span>{extraMessage}</span> } */}
            <br />
            <span
            style={{
              "fontStyle": "normal",
              "fontWeight": "400",
              "fontSize": "15px",
              "lineHeight": "16px",
              "display": "flex",
              "alignItems": "center",
              "letterSpacing": "0.02em",
              "color": "#A6A6A6",
              "paddingTop": "7px"
            }}  
            >{message}</span>
          </h6>
          <span>
            <AddAgent>
              <p>{time}</p>
            </AddAgent>
          </span>
          {/* </AddAgent> */}
        </AgentListBox>
      </div>
    );
  }
}
RecentList.contextTypes = {
  __: PropTypes.func
};

RecentList.props = {
  image: PropTypes.string,
  name: PropTypes.string,
  message: PropTypes.string,
  time: PropTypes.string
};

export default RecentList;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/dialpad/RecentList.js